import { message as antdMessage } from 'antd'
import React, { useEffect } from 'react'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { REQUEST_STATUS, TOAST_DUCK, TOAST_STATE } from '../../core/actions'

export const Toast = () => {
  const [Toast, contextHolder] = antdMessage.useMessage()
  const {
    toastState: { message, type },
  } = useGlobal()
  const { toastDispatch } = useGlobalDispatch()

  useEffect(() => {
    if (message && type) {
      if ([TOAST_STATE.INFO].includes(type)) {
        Toast.info(message)
      } else if ([TOAST_STATE.WARNING].includes(type)) {
        Toast.warning(message)
      } else if ([TOAST_STATE.SUCCESS, REQUEST_STATUS.SUCCESS].includes(type)) {
        Toast.success(message)
      } else if ([TOAST_STATE.ERROR, REQUEST_STATUS.FAILURE].includes(type)) {
        Toast.error(message)
      }
    }

    return () => {
      toastDispatch({ type: TOAST_DUCK.EOL })
    }
  }, [message])

  return <>{contextHolder}</>
}
